import BaseModel from 'src/model/base.model';
import LocationModel from 'src/model/location.model';
import { IDiscountInfo } from './product.model';

export interface IWarehouse {
  warehouseCode: string;
  description: string;
  quantity: number;
  default: boolean;
}
export interface IAlternatePartsList {
  productNumber: string;
  manufacturerCode: string;
  state: string;
  specialOrder: boolean;
}

export interface IAddress {
  number: number;
  name: string;
  line1: string;
  line2: string;
  line3: string;
  line4: string;
  postalCode: string;
  country: string;
  countryCode: string;
  stateCode: string;
  taxJurisdiction: string;
}

export interface IExtraProduct {
  status: string;
  productNumber: string;
  description: string;
  lineNumber: string;
  componentCode: string;
  manufacturer: string;
  critical: boolean;
  quantity: number;
  partnerPrice: string;
  retailPrice: string;
  availableQty: string;
}

class ProductDetailsModel extends BaseModel {
  public available?: boolean | null = false;
  public id?: number = 0;
  public name: string = '';
  public manufacturer: string = '';
  public description: string = '';
  public manufacturerCode: string = '';
  public partnerPrice: number = 0;
  public retailPrice: number = 0;
  public code: string = '';
  public stockCode: string = '';
  public notes: string = '';
  public productNumber: string = '';
  public qty: number = 0;
  public core: number = 0;
  public totalqty: number = 0;
  public modelsNumberTotalFound: number = 0;
  public state: string = '';
  public stateDescription: string = '';
  public warehouses: IWarehouse[] = [];
  public locations: LocationModel[] = [];
  public address: IAddress = {
    number: 0,
    name: '',
    line1: '',
    line2: '',
    line3: '',
    line4: '',
    postalCode: '',
    country: '',
    countryCode: '',
    stateCode: '',
    taxJurisdiction: ''
  };
  public images: string[] = [];
  public replacement: string = '';
  public inStock: boolean = false;
  public extras: string = '';
  public extraProducts: IExtraProduct[] = [];
  public extraQty: number;
  public extraTotalAmount: number;
  public favorite?: boolean;
  public isFavorite?: boolean;
  public idFavoriteItem?: number;
  public discountInfo?: IDiscountInfo;
  public replacedMfc?: string;
  public replacedPart?: string;
  public specialOrder: boolean;
  public isDropShip: boolean;
  public orderDetailStatus?: string;
  public replacementMfc?: string;
  public replacementPart?: string;
  public alternateProductManufacturer?: string;
  public alternateProductNumber?: string;
  public oemProductNumber?: string;
  public oemProductManufacturer?: string;
  public alternateProductsList: IAlternatePartsList[] = [];
  public longDesc?: string;
  public subPartNumber?: string;
  public weight?: string;
  public length?: string;
  public width?: string;
  public height?: string;
}

export default ProductDetailsModel;
